import * as React from 'react';
import { useLocation } from 'react-router';

import styled from 'styled-components';

interface ThemeContainerProps {
  className?: string;
  children: React.ReactNode;
}

export const ThemeContainer: React.FC<ThemeContainerProps> = ({
  className,
  children,
}) => {
  const location = useLocation();

  const hasBlackBackground = location.pathname.startsWith('/community');
  const isPublished = location.pathname.endsWith('/published');

  return (
    <section
      className={`${className} ${hasBlackBackground ? 'black-bg' : ''} ${
        isPublished ? 'published-bg' : ''
      }`}
    >
      {children}
    </section>
  );
};

export default styled(ThemeContainer)`
  background-color: ${({ theme }) => theme.colors.differentBackground};

  &.published-bg {
    position: relative;
    overflow-y: scroll;
    max-height: 100vh;
  }

  &.black-bg {
    background-color: ${({ theme }) => theme.colors.blackBackground};
  }

  &.black-bg {
    background-color: ${({ theme }) => theme.colors.blackBackground};
  }
`;
